module.exports = __webpack_public_path__ + "static/media/article_black.45663bdd.svg";